// Comprehensive shared styles for Impact PDF generation
export const sharedStyles = {
  message: {
    color: '#5B7185',
    fontSize: 9,
  },
  messageBold: {
    color: '#5B7185',
    fontSize: 9,
    bold: true,
  },
  messageSmall: {
    color: '#5B7185',
    fontSize: 7,
  },
  footer: {
    color: '#5B7185',
    fontSize: 5,
  },

  blueHeader: {
    color: '#5188ff',
    fontSize: 20,
    bold: true,
  },

  grayText: {
    fontSize: 10,
    color: '#5B7185',
  },

  grayTextLeft: {
    fontSize: 10,
    alignment: 'left',
    color: '#5B7185',
  },

  grayTextWithMargin: {
    fontSize: 10,
    color: '#5B7185',
    margin: [-10, 2, 0, 0],
  },

  grayTextWithMargin2: {
    fontSize: 10,
    color: '#5B7185',
    margin: [-10, 0, 0, 0],
  },

  grayTextStakeholder: {
    fontSize: 10,
    color: '#5B7185',
    alignment: 'left',
    margin: [-30, 7, 0, 0],
  },

  blueText: {
    color: '#5188ff ',
    fontSize: 10,
  },

  blueTextBold: {
    color: '#5188ff ',
    bold: true,
    fontSize: 10,
  },

  blueTextLarge: {
    color: '#5188ff ',
    fontSize: 14,
    alignment: 'left',
    margin: [-10, 0, 0, 0],
  },

  blueTextXLarge: {
    color: '#5188ff ',
    bold: true,
    fontSize: 30,
    margin: [-7, -10, 10, 0],
  },

  grayTextBold: {
    color: '#5B7185',
    fontSize: 16,
    bold: true,
  },

  grayTextMediumBold: {
    color: '#5B7185',
    fontSize: 14,
    bold: true,
  },

  blueTextMedium: {
    color: '#5188ff',
    fontSize: 12,
    margin: [0, 0, 0, 0],
    bold: true,
  },
  blueTextSmall: {
    color: '#5188ff',
    fontSize: 10,
    margin: [0, 0, 0, 0],
    bold: true,
  },


  // Table styles
  tableHeader: {
    margin: [0, 8, 0, 8],
    bold: true,
    fontSize: 10,
    color: '#343F49',
    alignment: 'center',
  },
  actual: {
    color: '#343F49',
    bold: false,
    fontSize: 10,
    alignment: 'center',
    margin: [0, 3, 0, 3],
  },
  target: {
    color: '#8FA5AF',
    alignment: 'center',
    fontSize: 10,
    margin: [0, 3, 0, 3],
  },
  metricUnit: {
    color: '#8FA5AF',
    fontSize: 8,
    margin: [39, 3, 0, 0],
  },
  metricName: {
    fontSize: 10,
    color: '#5B7185',
    bold: true,
    margin: [-20, 0, 0, 0],
  },
  sectionLabel: {
    fontSize: 10,
    color: '#111827',
    bold: true,
  },
  actualInfo: {
    color: '#5188ff ',
    bold: true,
    fontSize: 10,
    alignment: 'center',
    margin: [0, 3, 0, 3],
  },
  totalColumn: {
    color: '#5188ff',
    bold: true,
    fontSize: 10,
    alignment: 'center',
    margin: [0, 3, 0, 3],
    noWrap: true,
  },
}
